import { Grid } from "@mui/material";
import image from "assets/icons/package.svg";
import CustomImage from "components/CustomImage";
import CustomText from "components/typography/CustomText";
import React from "react";

export default function BoxesSummaryCount({ data = [] }) {
  const pies = data?.reduce((ret, cur) => ret + cur?.pies?.length, 0);
  return (
    <Grid container alignItems="center">
      <Grid item className="mr-5">
        <CustomImage src={image} alt="Boxes" />
      </Grid>
      <Grid item>
        <CustomText variant="body2" bold={600} color="secondary">
          {"Weekly Breakdown"}
        </CustomText>
        <CustomText variant="h4" bold color="secondary">
          {`${data?.length} Boxes`}
        </CustomText>
        <CustomText bold={600} color="med-blue">
          {`${pies} Pies`}
        </CustomText>
      </Grid>
    </Grid>
  );
}
